import { useCallback, useContext } from 'react';
import { FileUploadsStateContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';
import { useFileUploadEffects } from './useFileUploadEffects';

export const useAbortUpload = () => {
  const state = useContext(FileUploadsStateContext);

  const effects = useFileUploadEffects();

  return useCallback((fileIdentifier: string) => {
    const upload = state.uploads[fileIdentifier];
    const fileUpload = state.valid.find(f => f.identifier === fileIdentifier);

    if (upload) {
      upload.abort().catch(() => undefined);
    }

    return effects.abort({
      fileUploadId: fileUpload.id,
      workspaceId: fileUpload.data.workspaceId,
    }).catch(() => undefined);
  }, [
    effects,
    state.uploads,
    state.valid,
  ]);
};

export default useAbortUpload;